export const PROD_API = 'https://api-2.siteletsbook.com.br';
export const DEV_API = 'https://dev-api-2.siteletsbook.com.br';
export const LOCAL_API = 'http://localhost:3000';

export const LOCAL_SITE = 'http://localhost:8000';
